/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    enrollDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.Enroll driver in Drive Change',
        defaultMessage: "Enroll driver in Drive Change? Wawanesa's telematics program",
    },
    enrollmentDetails: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.Enrollment Details',
        defaultMessage: 'Enrollment Details',
    },
    driveChangeContactInfoMessage: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.driveChangeContactInfoMessage',
        defaultMessage:
            'Contact information for the driver must be added to bind the policy. This information will be used for app enrollment.',
    },
    driverEmailAddress: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.emailAddress',
        defaultMessage: "Driver's e-mail address",
    },
    driverConfirmEmailAddress: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.confirmEmailAddress',
        defaultMessage: 'Confirm email address',
    },
    verifyEmailButton: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.Verify Email',
        defaultMessage: 'Verify Email',
    },
    emailValid: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.emailValid',
        defaultMessage: 'The email has been verified',
    },
    invalidtls: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.invalidtls',
        defaultMessage:
            'The email does not comply with our security standards and cannot be used to receive documents.',
    },
    unavailable: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.unavailable',
        defaultMessage:
            'The verification could not be completed. Please continue and the email will be verified later.',
    },
    invalid: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.invalid',
        defaultMessage: 'The email is invalid. A valid email will be required to bind the policy.',
    },
    emptyEmail: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.emptyEmail',
        defaultMessage: 'Email address is required for Preferred Distribution Method: Digital',
    },
    driversCellPhone: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.driversCellPhone',
        defaultMessage: "Driver's mobile phone",
    },
    previousInsurerDiscount: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.previousInsurerDiscount',
        defaultMessage: 'The discount percentage received from their previous insurer',
    },
    activationDate: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.activationDate',
        defaultMessage: 'Activation date',
    },
    enrollmentStatus: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.enrollmentStatus',
        defaultMessage: 'Enrollment status',
    },
    lastUpdatedOn: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.lastUpdatedOn',
        defaultMessage: 'Last updated on',
    },
    unenrollmentReason: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.unenrollmentReason',
        defaultMessage: 'Unenrollment reason',
    },
    unenrollmentDate: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.unenrollmentDate',
        defaultMessage: 'Unenrollment date',
    },
    ratedKilometersDriven: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.ratedKilometersDriven',
        defaultMessage: 'Rated kilometers driven',
    },
    ratedDriverScore: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.ratedDriverScore',
        defaultMessage: 'Rated driver score',
    },
    currentDriverScore: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.currentDriverScore',
        defaultMessage: 'Current driver score',
    },
    currentKilometersDriven: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.currentKilometersDriven',
        defaultMessage: 'Current kilometers driven',
    },
    ratedTripsTaken: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.ratedTripsTaken',
        defaultMessage: 'Rated trips taken',
    },
    currentTripsTaken: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.currentTripsTaken',
        defaultMessage: 'Current trips taken',
    },
    lastTripDate: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.lastTripDate',
        defaultMessage: 'Last trip date',
    },
    lastSessionDate: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.lastSessionDate',
        defaultMessage: 'Last session date',
    },
    drivingDetails: {
        id: 'wmic-pe-capability-gateway-common-pa-react.drive-change-telematics.drivingDetails',
        defaultMessage: 'Driving Details',
    },
    ratedDriverDetails: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.ratedDriverDetails',
        defaultMessage: 'Rated Driver Details',
    },
    currentDriverDetails: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.currentDriverDetails',
        defaultMessage: 'Current Driver Details',
    },
    weeklyScores: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.weeklyScores',
        defaultMessage: 'Weekly Scores',
    },
    sevenDayRollingScore: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.sevenDayRollingScore',
        defaultMessage: '7 Day Rolling Score',
    },
    previousWeekRollingScore: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.previousWeekRollingScore',
        defaultMessage: 'Previous Week Rolling Score',
    },
    adjustmentDates: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.adjustmentDates',
        defaultMessage: 'Adjustment Dates',
    },
    hasAlreadyEnrolledInAnotherPolicy: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.hasAlreadyEnrolledInAnotherPolicy',
        defaultMessage: 'Driver is enrolled in Drive Change and can only be enrolled on one policy',
    },
    emailIsAlreadyEnrolledInDriveChange: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.emailIsAlreadyEnrolledInDriveChange',
        defaultMessage: 'Given email address is already in use and active for Drive Change',
    },
    verifyEmail: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.verifyEmail',
        defaultMessage: 'Please verify email',
    },
    monthlyAutomatedPaymentRequiredMessage: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICDriveChangeTelematics.WMICDriveChangeTelematicsComponent.monthlyAutomatedPaymentRequiredMessage',
        defaultMessage:
            'Monthly Automated Payment Plan is required for Drive Change policies. Billing options must be updated before enrolling in Drive Change.',
    },
});
